import React from "react"
import { CCPARequest } from "reaction/Components/v2/CCPARequest"

export const ReactionCCPARequest = props => <CCPARequest {...props} />
